import { NavigationItem } from "../navigation-item"

export class DashboardNavigationItem extends NavigationItem {
  readonly id = "dashboard"
  readonly label = "Dashboard"
  readonly href = "/dashboard"
  readonly iconName = "dashboard-icon"
  readonly isExternal = false

  readonly tabs = []

  readonly subItems = []
}
